import { createContext } from 'react';
var defaultHeaderCtx = {
  isEUDC: false,
  lang: 'en',
  session: undefined,
  user: undefined,
  pageURL: undefined,
  pageName: undefined
};
var HeaderContext = /*#__PURE__*/createContext(defaultHeaderCtx);
export default HeaderContext;
//# sourceMappingURL=HeaderContext.js.map